import ElasticComponentContext from '@/features/shared/ElasticComponent/ElasticComponentContext';
import { MuiSwitch } from '@/features/shared/material-ui';
import PartnerOnly from '@/features/shared/PartnerOnly';
import { parseBooleanStringToBoolean } from '@/utils/helpers';
import { get, pipe } from 'lodash/fp';
import React, { useContext, useEffect, useState } from 'react';
import { parsePartnerOnlyFilter } from '../SearchResult.utils';
import usePartnerOnlySwitchFilterStyles from './PartnerOnlySwitchFilter.styles';

const PartnerOnlySwitchFilter = () => {
  const [filterByPartnerOnly, setFilterByPartnerOnly] = useState<boolean>(false);
  const classes = usePartnerOnlySwitchFilterStyles();
  const { queryParams, updateQueryParams } = useContext(ElasticComponentContext);

  const switchValueChange = (event: any) => {
    const isChecked = event.target.checked;
    setFilterByPartnerOnly(isChecked);
    updateQueryParams('is_partner_only', [String(isChecked)], true);
  };

  useEffect(() => {
    const getIsPartnerOnly = pipe(
      parsePartnerOnlyFilter,
      get('is_partner_only'),
      parseBooleanStringToBoolean,
    );

    const isPartnerOnly = getIsPartnerOnly(queryParams?.filters || {});

    setFilterByPartnerOnly(isPartnerOnly);
  }, [queryParams]);

  return (
    <div className={classes.root}>
      <PartnerOnly />
      <MuiSwitch
        checked={filterByPartnerOnly}
        className={classes.switch}
        onChange={switchValueChange}
        size="small"
      />
    </div>
  );
};

export default PartnerOnlySwitchFilter;
